"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PASSWORD_REGEX = exports.DOMAIN_PARTS = exports.ZIP_CODE_REGEX = exports.US_PHONE = exports.ALPHA_NUM_REGEX = exports.NAME_REGEX = exports.EMAIL_REGEX = exports.DATE_FORMAT_REGEX = void 0;
/**
 * Regular expression used for date format
 *
 * @public
 */
exports.DATE_FORMAT_REGEX = /^\d{2}\/\d{2}\/\d{4}$/;
/**
 * Regular expression used for email validation
 *
 * @public
 */
exports.EMAIL_REGEX = /^([\w-+]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?$)/;
/**
 * Regular expression used for name validation
 *
 * @public
 */
exports.NAME_REGEX = /^[a-z\u0027\u2019\u0020\u00E0-\u00FC]{2,}$/i;
/**
 * Regular expression used for US phone validation
 *
 * @public
 */
exports.ALPHA_NUM_REGEX = /^[a-z0-9 \u0026\u002D\u0028\u0029\u0027\u002C\u002E]+$/i;
/**
 * Regular expression used for US phone validation
 *
 * @public
 */
exports.US_PHONE = /^1?\W*([2-9][0-8][0-9])\W*([0-9][0-9]{2})\W*([0-9]{4})$/;
/**
 * Regular expression used for ZIP code format validation
 *
 * @public
 */
exports.ZIP_CODE_REGEX = /^\d{5}$/;
/**
 * Regular expression used for domain parts
 *
 * @public
 */
exports.DOMAIN_PARTS = /^(https?:\/\/)?(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)?(\?[^#]*|)$/;
/**
 * Regular expression used for Password validation
 *
 * 8 characters minimum
 * 1 upper case character
 * 1 lower case character
 * 1 number
 *
 * @public
 */
exports.PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d].{7,}$/;
//# sourceMappingURL=regex.js.map